import { render, staticRenderFns } from "./AddAddressBlock.vue?vue&type=template&id=ff87b286&scoped=true&"
import script from "./AddAddressBlock.vue?vue&type=script&lang=js&"
export * from "./AddAddressBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff87b286",
  null
  
)

export default component.exports